import React from "react";
import { Loader, Icon } from "semantic-ui-react";
import { size, map } from "lodash";
import { SyllabuSubjectGradeItem } from "../SyllabuSubjectGradeItem";

export function ListSyllabuSubjectGrade(props) {
  const { gradeId, syllabuSubjectGrades, onReload } = props;

  if (!gradeId) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "3rem 1rem",
        color: "#aaa",
        gap: "0.75rem",
      }}>
        <Icon name="hand point up outline" size="huge" style={{ margin: 0 }} />
        <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
          Selecciona un nivel y un grado para ver las asignaturas
        </span>
      </div>
    );
  }

  if (!syllabuSubjectGrades) return <Loader active inline="centered" />;
  if (size(syllabuSubjectGrades) === 0) return "No se ha encontrado asignaturas relacionadas a la malla curricular.";

  return map(syllabuSubjectGrades, (syllabuSubjectGrade) => (
    <SyllabuSubjectGradeItem key={syllabuSubjectGrade.id} syllabuSubjectGrade={syllabuSubjectGrade} onReload={onReload} />
  ));
}
